class CollectionGrid extends window.BAOv2.CustomElement {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.listeners.add(this, 'click', this.setClickedProduct.bind(this))
    this.listeners.add(document, 'DOMContentLoaded', this.scrollToPreviousPosition.bind(this))
  }

  scrollToPreviousPosition () {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    const savedHandle = sessionStorage.getItem('BAO-PlpClickedProduct')

    if (!savedHandle) return

    const offsetTop = this.getOffsetTop(savedHandle)

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    })

    sessionStorage.removeItem('BAO-PlpClickedProduct')
  }

  setClickedProduct (event) {
    const target = event.target.closest('[data-product-handle]')
    const productHandle = target?.getAttribute('data-product-handle')

    if (!productHandle) return

    sessionStorage.setItem('BAO-PlpClickedProduct', productHandle)
  }

  getOffsetTop (handle) {
    const targetElement = document.querySelector(`[data-product-handle="${handle}"]`)
    const headerWrapper = document.querySelector('[data-restore-scroll-external-el="header"]')
    const searchBar = document.querySelector('[data-restore-scroll-external-el="search"]')

    const headerOffset = headerWrapper ? headerWrapper.offsetHeight : 0
    const searchBarOffset = searchBar ? searchBar.offsetHeight : 0
    const targetElementOffset = targetElement ? targetElement.getBoundingClientRect().top : 0

    return targetElementOffset + window.scrollY - headerOffset - searchBarOffset
  }
}

if (!customElements.get('collection-grid')) {
  customElements.define('collection-grid', CollectionGrid)
}
